import { AsteriskIcon } from 'lucide-react';

const MandatoryAsterisk = () => {
  return <AsteriskIcon className="text-danger mb-2 inline" size={'12px'} />;
};

export default MandatoryAsterisk;
